import { useLocation } from 'react-router-dom';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { FeatureFlagUseCase } from '@ibk/shared-types';
export function useIsEmissorFeedbackFlow() {
    const location = useLocation();
    const { isFeatureFlagWhiteListed } = useFeatureFlag();
    const locationState = location.state;
    const isEmissorEnabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.BENEFICIOS_EMISSOR_ENABLED);
    return locationState?.isEmissorFlow ?? isEmissorEnabled;
}
